module.exports = __webpack_public_path__ + "980849b28dd0f3815293991a041889f9.jpg";